import { t } from "../../i18n";
import { Grid2X2, ImagePlus } from "lucide-react";
import { useState } from "react";
import type { PreviewAsset } from "./GameAssetPreview.types";

export function SheetPreview({
  asset,
  kind,
}: {
  asset: PreviewAsset;
  kind: "sprite" | "tileset";
}) {
  const [columns, setColumns] = useState(4);
  const [rows, setRows] = useState(4);
  return (
    <div className="space-y-2">
      <div className="relative overflow-hidden rounded-xl bg-[linear-gradient(45deg,#e7e5e4_25%,transparent_25%),linear-gradient(-45deg,#e7e5e4_25%,transparent_25%),linear-gradient(45deg,transparent_75%,#e7e5e4_75%),linear-gradient(-45deg,transparent_75%,#e7e5e4_75%)] bg-[length:20px_20px] bg-[position:0_0,0_10px,10px_-10px,-10px_0px] dark:bg-stone-800">
        <img
          src={asset.url}
          alt={asset.name}
          className="block max-h-80 w-full object-contain"
        />
        <div
          className="pointer-events-none absolute inset-0 opacity-60"
          style={{
            backgroundImage:
              "linear-gradient(to right, transparent calc(100% - 1px), rgba(99,102,241,.8) 1px), linear-gradient(to bottom, transparent calc(100% - 1px), rgba(99,102,241,.8) 1px)",
            backgroundSize: `${100 / columns}% ${100 / rows}%`,
          }}
        />
      </div>
      <div className="flex items-center gap-3 text-xs text-stone-500 dark:text-stone-400">
        {kind === "sprite" ? <ImagePlus size={14} /> : <Grid2X2 size={14} />}
        <label className="flex items-center gap-1">
          {t("Cols")}{" "}
          <input
            aria-label={t("Sprite columns")}
            className="w-14"
            type="number"
            min="1"
            max="16"
            value={columns}
            onChange={(event) =>
              setColumns(
                Math.max(1, Math.min(16, Number(event.target.value) || 1)),
              )
            }
          />
        </label>
        <label className="flex items-center gap-1">
          {t("Rows")}{" "}
          <input
            aria-label={t("Sprite rows")}
            className="w-14"
            type="number"
            min="1"
            max="16"
            value={rows}
            onChange={(event) =>
              setRows(
                Math.max(1, Math.min(16, Number(event.target.value) || 1)),
              )
            }
          />
        </label>
      </div>
    </div>
  );
}
